<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       width="46px" height="38px" viewBox="0 0 46 38" enable-background="new 0 0 46 38" xml:space="preserve">
<path fill="#FFFFFF" d="M23.719,31.529c0.013-0.01,1.274-1.045,2.679-1.185c1.656-0.162,2.802,0.006,4.039,0.187
	c1.296,0.19,2.661,0.392,4.581,0.201C35.576,30.678,36,30.224,36,29.684V7.301c0-0.297-0.13-0.581-0.36-0.781
	c-0.229-0.199-0.538-0.3-0.843-0.265c-1.65,0.159-2.796-0.004-4.034-0.188c-1.296-0.19-2.656-0.39-4.588-0.199
	c-1.309,0.128-2.463,0.725-3.169,1.175c-0.697-0.452-1.836-1.047-3.144-1.175c-1.928-0.192-3.301,0.009-4.608,0.199
	c-1.242,0.18-2.393,0.347-4.053,0.188c-0.304-0.034-0.613,0.066-0.842,0.265C10.13,6.72,10,7.004,10,7.301v22.383
	c0,0.54,0.423,0.994,0.981,1.047c0.548,0.054,1.052,0.077,1.521,0.077l0,0c1.182,0,2.146-0.14,3.079-0.277
	c1.246-0.18,2.399-0.348,4.058-0.187c1.386,0.137,2.593,1.144,2.632,1.178c0.208,0.18,0.467,0.269,0.729,0.269
	C23.258,31.791,23.514,31.703,23.719,31.529z M15.254,28.45c-0.982,0.143-1.902,0.277-3.278,0.25V8.421
	c1.546,0.03,2.59-0.125,3.605-0.273c1.247-0.181,2.402-0.347,4.059-0.187c1.4,0.138,2.62,1.168,2.63,1.177
	c0.413,0.357,1.033,0.361,1.449,0.008c0.013-0.01,1.274-1.045,2.679-1.185c1.656-0.162,2.802,0.005,4.039,0.187
	c1.009,0.148,2.069,0.299,3.675,0.273V28.7c-1.437,0.028-2.372-0.106-3.349-0.25c-1.296-0.19-2.656-0.389-4.588-0.197
	c-1.309,0.127-2.463,0.724-3.169,1.173c-0.697-0.45-1.836-1.046-3.144-1.173c-0.552-0.055-1.057-0.078-1.53-0.078
	C17.151,28.175,16.188,28.314,15.254,28.45z M30.965,20.755h-3.201l4.1-8.848c0.141-0.302,0.115-0.643-0.072-0.921
	c-0.183-0.275-0.491-0.436-0.826-0.436h-4.529c-0.543,0-0.987,0.431-0.987,0.962c0,0.53,0.444,0.964,0.987,0.964h2.996l-4.102,8.847
	c-0.138,0.302-0.11,0.646,0.074,0.921c0.184,0.276,0.493,0.439,0.83,0.439h4.73c0.543,0,0.988-0.434,0.988-0.964
	C31.953,21.188,31.508,20.755,30.965,20.755z M24.52,15.494h-1.453c-0.542,0-0.985,0.43-0.985,0.96c0,0.531,0.443,0.965,0.985,0.965
	h1.453c0.545,0,0.988-0.434,0.988-0.965C25.508,15.924,25.064,15.494,24.52,15.494z M18.807,11.229l3.207,10.21
	c0.159,0.508-0.136,1.046-0.658,1.201c-0.522,0.15-1.08-0.148-1.233-0.64l-0.428-1.369h-3.587l-0.417,1.361
	c-0.152,0.502-0.703,0.797-1.228,0.65c-0.523-0.149-0.823-0.687-0.667-1.199l3.121-10.207c0.119-0.405,0.508-0.687,0.944-0.687
	C18.299,10.55,18.68,10.823,18.807,11.229z M19.086,19.109l-1.211-5.083l-1.18,5.083H19.086z M32.926,26.131
	c-0.048,0.406-0.429,0.726-0.864,0.726c-0.025,0-0.055-0.002-0.078-0.004c-0.485-0.051-0.958-0.119-1.435-0.188
	c-0.896-0.129-1.744-0.251-2.78-0.251c-0.442,0-0.884,0.022-1.351,0.068c-1.521,0.148-2.844,1.232-2.855,1.243
	c-0.156,0.129-0.359,0.195-0.562,0.195s-0.406-0.065-0.563-0.195c-0.012-0.01-1.334-1.095-2.855-1.243
	c-0.466-0.045-0.907-0.068-1.351-0.068c-1.037,0-1.885,0.122-2.78,0.251c-0.478,0.069-0.949,0.137-1.435,0.188
	c-0.023,0.002-0.052,0.004-0.077,0.004c-0.437,0-0.817-0.319-0.865-0.726c-0.048-0.444,0.292-0.835,0.757-0.894
	c1.142-0.144,3.244-0.449,4.397-0.449c0.501,0,1.002,0.025,1.526,0.078c1.291,0.124,2.426,0.704,3.155,1.169l0.085,0.055L23,26.086
	l0.006,0.004l0.084-0.055c0.729-0.465,1.865-1.045,3.155-1.169c0.525-0.053,1.025-0.078,1.526-0.078
	c1.154,0,3.256,0.305,4.396,0.449C32.634,25.296,32.974,25.687,32.926,26.131z"/>
</svg>
</template>

<script>
    export default {
        name: "GlossaryIcon"
    }
</script>

<style scoped>

</style>